import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { CONTEXT_LOG_SUBJECT_TYPES } from "@/types/contextLogTypes";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useShallow } from "zustand/react/shallow";
import { BasicButton } from "../buttons/BasicButton";
import { ContextLogInput } from "../contextLogs/ContextLogInput";

export function ValidationOverrideModal(props: {validationId: string}) {
  const { validationId } = props;
  const userInfo = useGlobalStore(useShallow((state) => state.userClass));
  const [show, setShow] = useState(false);
  const [note, setNote] = useState('');
  const [noteError, setNoteError] = useState('');
  const [userEmail, setUserEmail] = useState(userInfo?.email || '');
  const [userEmailError, setUserEmailError] = useState('');
  const addContextLog = useParameterStore(useShallow((state) => state.addContextLog));

  const handleConfirm = () => {
    if (!note || !userEmail) {
      if (!note) {
        setNoteError(I18n.get('requiredField'));
      }
      if (!userEmail) {
        setUserEmailError(I18n.get('requiredField'));
      }
      return;
    }
    void addContextLog({
      note,
      userEmail,
      subjectType: CONTEXT_LOG_SUBJECT_TYPES.VALIDATION,
      subjectId: validationId,
    });
    clearForm();
    setShow(false);
  };

  const onCancel = () => {
    clearForm();
    setShow(false);
  };

  const clearForm = () => {
    setNote('');
    setNoteError('');
    setUserEmail(userInfo?.email || '');
    setUserEmailError('');
  };

  return (
    <>
      <button type='button' className='btn btn-sm btn-warning text-nowrap' onClick={() => setShow(true)}>{I18n.get('overrideValidation')}</button>
      <Modal show={show} onHide={onCancel} centered size='lg'>
        <Modal.Header closeButton className='bg-warning text-white'>
          <Modal.Title>{I18n.get('overrideValidation')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex flex-column gap-3'>
            <p style={{whiteSpace: 'pre-wrap'}} className="d-flex">
              {I18n.get('overrideValidationDescription')}
            </p>
            <ContextLogInput note={note} setNote={setNote} noteError={noteError} userEmail={userEmail} setUserEmail={setUserEmail} userEmailError={userEmailError} contextLogLabelText={I18n.get('reasonForOverride')} />
            <div className="d-flex justify-content-end gap-2">
              <BasicButton className="btn btn-secondary" onClick={onCancel} label={I18n.get('cancel')} />
              <BasicButton title={I18n.get('confirmAction', {action: I18n.get('overrideValidation')})} className="btn btn-warning" onClick={() => handleConfirm()} label={I18n.get('overrideValidation')} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
